import React from 'react';
import { Link } from 'react-router-dom';
import LiquidGlass from './LiquidGlass';

export default function Footer() {
  return (
    <footer className="mt-auto py-3">
      <LiquidGlass className="mx-4 mb-3 px-6 py-3" bgOpacity="high">
        <div className="container mx-auto">
          <div className="flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600">
            <div>
              © {new Date().getFullYear()} Pacer Results. All rights reserved.
            </div>
            <div className="flex gap-6 mt-2 sm:mt-0">
              <Link to="/terms" className="hover:text-gray-800 transition-colors duration-200">Terms</Link>
              <Link to="/privacy" className="hover:text-gray-800 transition-colors duration-200">Privacy</Link>
            </div>
          </div>
        </div>
      </LiquidGlass>
    </footer>
  );
}